<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    :class="size"
    viewBox="0 0 200.000000 200.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
      :fill="color"
      stroke="none"
    >
      <path
        d="M307 1685 l-58 -63 3 -101 3 -101 165 165 165 165 -110 -1 -110 0
-58 -64z"
      />
      <path
        d="M522 1480 l-273 -268 3 -101 3 -101 370 370 370 370 -100 0 -100 -1
-273 -269z"
      />
      <path
        d="M732 1270 l-483 -479 3 -101 3 -102 587 581 586 581 -106 0 -107 -1
-483 -479z"
      />
      <path
        d="M946 1063 l-696 -686 0 -64 0 -63 53 0 52 0 698 698 697 697 0 53 0
52 -54 0 -53 0 -697 -687z"
      />
      <path
        d="M1155 840 l-590 -590 105 0 105 0 488 488 488 488 -3 102 -3 102
-590 -590z"
      />
      <path
        d="M1370 625 l-375 -375 105 0 105 0 273 273 273 273 -3 102 -3 102
-375 -375z"
      />
      <path
        d="M1580 415 l-165 -165 105 0 106 0 62 63 63 63 -3 102 -3 102 -165
-165z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: "w-6 h-6",
    },
    color: {
      type: String,
      default: "white",
    },
  },
};
</script>
<style></style>
